// Values must match dwo_feature_flag.flag_key in the backend.
export enum FeatureFlagKey {
  EnableCableWorkLine = 'enableCableWorkLine',
  EnableWeightHandling = 'enableWeightHandling',
  EnableWorkOrderFeedback = 'enableWorkOrderFeedback',
  ShowDownloadButton = 'showDownloadButton',
  EnableProcosysLink = 'enableProcosysLink',
  EnableRedlineMarkup = 'enableRedlineMarkup',
  ShowTimeDocuments = 'showTimeDocuments',
  EnableDocumentProcessStatus = 'enableDocumentProcessStatus',
  ShowLegacyOfflineUi = 'showLegacyOfflineUi',
}
